var map = {
	"./agoda-logo.svg": "2982",
	"./bcom-logo.svg": "eec6",
	"./booking-logo-old.svg": "2ec0",
	"./booking-logo.svg": "21b0",
	"./ctrip-logo.svg": "fa77",
	"./eshet-logo.svg": "34ea",
	"./expedia-logo.svg": "a689",
	"./fliggy-logo.svg": "cbbe",
	"./google-logo-old.svg": "307b",
	"./google-logo.svg": "0e30",
	"./hotels.com-logo.svg": "5a5e",
	"./hoteltonight-logo.svg": "e7d5",
	"./hrs-logo.svg": "4580",
	"./ikyu-logo.svg": "25be",
	"./issta-logo.svg": "363d",
	"./logo-placeholder.svg": "a3e1",
	"./makemytrip-logo.svg": "4554",
	"./meituan-logo.svg": "2fba",
	"./priceline-logo.svg": "1f1f",
	"./qantas-logo.svg": "5994",
	"./rakuten-logo.svg": "9427",
	"./tiket-logo.svg": "916e",
	"./traveloka-logo.svg": "7674",
	"./trip-logo.svg": "4ab2",
	"./tripadvisor-logo.svg": "a73a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a77";